import $ from "jquery";

export const getPartySize = () => {
    let partySize = parseInt($('input[name="amountOfPersons"]').val() as string);
    if (isNaN(partySize) || partySize === undefined || partySize === null || partySize === 0) {
        partySize = 1;
    }
    return partySize;
};
